export default __webpack_public_path__ + "17aafb2046704e80698d221ce9715cce.svg";